<template>
	<div id="app" style="height: 100%">
		<DefaultLayout v-if="getLayout === 'default'">
			<router-view />
		</DefaultLayout>

		<PlainLayout v-if="getLayout === 'plain'">
			<router-view />
		</PlainLayout>

		<ActiveCustomerHandler/>
	</div>
</template>

<script>
import DefaultLayout from '@/layouts/Default';
import PlainLayout from '@/layouts/Plain';
import ActiveCustomerHandler from './components/active-customer-handler';
import { mapActions } from 'vuex';

export default {
  components: {
    DefaultLayout, // ✅ Use correct name here
    PlainLayout,
    ActiveCustomerHandler
  },

  data: () => ({
    pendingAppUpdate: false
  }),

  computed: {
    getLayout() {
      return this.$route?.meta?.layout
        ? this.$route.meta.layout.toLowerCase()
        : 'default';
    }
  },

  created() {
    window.addEventListener('resize', this.checkWidth);
    window.addEventListener('app-update-available', this.onAppUpdateAvailable);
    this.checkWidth();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.checkWidth);
    window.removeEventListener('app-update-available', this.onAppUpdateAvailable);
  },

  watch: {
    '$route.name'() {
      this.tryApplyAppUpdate();
    }
  },

  methods: {
    ...mapActions('appStore', ['setMobileState']),

    onAppUpdateAvailable() {
      this.pendingAppUpdate = true;
      this.tryApplyAppUpdate();
    },

    tryApplyAppUpdate() {
      if (!this.pendingAppUpdate) return;

      if (this.$route?.name === 'RoundView') {
        window.dispatchEvent(new CustomEvent('app-update-check'));
        return;
      }

      this.pendingAppUpdate = false;
      window.location.reload();
    },

    checkWidth() {
      this.setMobileState(window.innerWidth < 1024);
    }
  }
};
</script>

